import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { clsx as Y } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { forwardRef as Z, useRef as E, useState as ee, useEffect as O } from "react";
import { remCalc as re } from "../../style/base/index.js";
import { RocheUIStoryType as k } from "../../types/roche-story-type.js";
import { normalizeVideoId as te } from "../../utils/normalize-video-id.js";
import { RocheUIButton as oe } from "../button/roche-button.js";
import { RocheUIDate as se } from "../date/roche-date.js";
import { RocheUIIcon as ie } from "../icon/roche-icon.js";
import { RocheUIImage as ae } from "../image/roche-image.js";
import { RocheUIImageFit as ne, RocheUIImageRatio as s } from "../image/roche-image.types.js";
import { RocheUIVideoPlayer as ce } from "../video-player/roche-video-player.js";
import r from "./roche-story-teaser.module.scss.js";
import { RocheUIStoryTeaserLayout as o, RocheUIIconVariant as x } from "./roche-story-teaser.types.js";
const Te = /* @__PURE__ */ Z(
  ({
    layout: t,
    teaserType: n = k.DEFAULT,
    teaserTitle: m,
    teaserDescription: f,
    teaserImage: l,
    teaserVideoId: S,
    teaserImageAlt: h,
    teaserUrl: I,
    teaserDate: R,
    dateTimeValue: v,
    teaserTagLabel: B,
    ctaLabel: p,
    ctaVisuallyHiddenText: F,
    unpublished: H,
    slot: A,
    playLabel: D,
    pauseLabel: b,
    onVideoStateChange: _,
    onTeaserLinkClick: N,
    awsServiceBaseUrl: j,
    imageFit: g = ne.COVER,
    linkRef: G
  }, u) => {
    const c = E(null), M = E(null), y = G ?? M, [P, X] = ee(0), V = te(S), d = V !== "", C = !!l, $ = n !== k.DEFAULT, z = t === o.VARIANT_C, K = (() => {
      switch (t) {
        case o.VARIANT_A:
          return { ratio: s.NORMAL };
        case o.VARIANT_B:
          return { ratio: s.SIXTOFIVE };
        case o.VARIANT_C:
          return { ratio: s.ORIGINAL, forceHeight: 480 };
        default:
          return { ratio: s.ORIGINAL };
      }
    })(), q = C && /* @__PURE__ */ e(ae, { src: l ?? "", alt: h, imageFit: g, ...K }), J = d && /* @__PURE__ */ e(
      ce,
      {
        awsServiceBaseUrl: j,
        service: "aws",
        videoId: V,
        previewAlt: h ?? "",
        playLabel: D ?? "",
        pauseLabel: b ?? "",
        videoFit: g,
        videoLoop: !0,
        onVideoStateChange: (a) => {
          _ && _(a);
        },
        ...(() => {
          switch (t) {
            case o.VARIANT_A:
              return { videoRatio: s.NORMAL };
            case o.VARIANT_B:
              return { videoRatio: s.SIXTOFIVE };
            case o.VARIANT_C:
              return { fillParentHeight: !0 };
            default:
              return {};
          }
        })()
      }
    );
    O(() => {
      t !== "story-teaser--variant-a" && c.current && X(c.current.clientHeight);
    }, [t, f]), O(() => {
      const a = (W) => {
        var L;
        W.key === "Escape" && ((L = y.current) == null || L.blur());
      };
      return window.addEventListener("keydown", a), () => {
        window.removeEventListener("keydown", a);
      };
    }, []);
    const T = (C || d) && /* @__PURE__ */ e("div", { className: r["story-teaser__media-container"], children: d ? J : q }), w = /* @__PURE__ */ i("div", { className: r["story-teaser__details"], children: [
      $ && /* @__PURE__ */ i("div", { className: r["story-teaser__tag"], children: [
        x[n] && /* @__PURE__ */ e(ie, { icon: x[n], height: `${re(20)}rem` }),
        /* @__PURE__ */ e("span", { children: B })
      ] }),
      /* @__PURE__ */ i("div", { className: r["story-teaser__description-container"], children: [
        /* @__PURE__ */ e("h3", { className: r["story-teaser__title"], children: z ? m : /* @__PURE__ */ e("a", { ref: y, className: r["story-teaser__link"], href: I, onClick: N, children: m }) }),
        /* @__PURE__ */ e("p", { ref: c, className: r["story-teaser__description"], children: f })
      ] }),
      R && v && t === "story-teaser--variant-a" && /* @__PURE__ */ e("div", { className: r["story-teaser__date"], children: /* @__PURE__ */ e(se, { displayDate: R, dateTimeValue: v }) }),
      t === "story-teaser--variant-c" && p && /* @__PURE__ */ e(
        oe,
        {
          text: p,
          href: I,
          visuallyHiddenText: F,
          onClick: N
        }
      )
    ] }), U = Y(r["story-teaser"], r[t], {
      [r["story-teaser--unpublished"]]: H
    }), Q = /* @__PURE__ */ i(
      "div",
      {
        ref: u,
        className: U,
        style: { "--teaser-hover-offset": `${P}px` },
        slot: A,
        children: [
          T,
          w
        ]
      }
    );
    return t === "story-teaser--variant-c" ? /* @__PURE__ */ i("div", { ref: u, className: U, slot: A, children: [
      T,
      w
    ] }) : Q;
  }
);
export {
  Te as RocheUIStoryTeaser
};
